import React from 'react';

import { ReactComponent as ArrowDown } from '../../../assets/icons/ArrowDown.svg';

import Button from '../Button/Button';

import classes from './ShowArrowButton.module.scss';

const ShowArrowButton = ({ showState, onClick, reverse, iconPosition = 'right', color }) => {
  return (
    <Button
      classNameIcon={!reverse ? (showState ? classes.up : '') : showState ? '' : classes.up}
      onClick={onClick}
      Icon={ArrowDown}
      iconPosition={iconPosition}
      color={color}
      custom='quaternary'>
      {showState ? 'Ocultar' : 'Mostrar'}
    </Button>
  );
};

export default ShowArrowButton;
